import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip'
import '../../../../node_modules/react-datetime/css/react-datetime.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import queryString from 'query-string';
import 'bootstrap-daterangepicker/daterangepicker.css';
import NotificationSystem from 'react-notification-system';
import ReactTable from 'react-table';
import '../../../../src/assets/css/react-table.css'
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import {
    _addNotification, _addNotificationError,
    formatDate, allowNumericWithdecimal, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, showFile,
    convertTwoDecimalPoint, getSessionStartEndDates, getModuleEnum, getAccessLevelByModule, getSchoolGrades
} from "../../../server/util";
import { get, postWithHeaders, postWithHeadersResponse, _delete } from "../../../server/actions";
import { currency_symbol } from '../../../server/constants'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { BeatLoader } from 'react-spinners';
import $ from "jquery";
import AccountHistory from "./AccountHistory";
import LowBalReport from "./LowBalReport";
import moment from 'moment';
import Modal from 'react-modal'
import BcacPayments from './bcacPayments';
var converter = require('number-to-words');
var _ = require('lodash');
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '55%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
const modEnum = getModuleEnum();
let gradeList = [];
class PaymentReports extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            transactionData: [],
            purchaseData: [],
            students: [],
            studentsCount: 0,
            data: [],
            columns: [],
            selection: [],
            selectAll: false,
            selectedRows: [],
            currentPage: 0,
            currentGrade: '0',
            displayRecId: '',
            tdataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            purchaseDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            eventPayDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            lowBalReport: [],
            mapKeyVal: {},
            modalIsOpen: false,
            accountHistStudentData: [],
            depositSummery: [],
            eventsPayments: [],
            tabSelect: '',
            lowBalFilter: {
                filter: 'DEFAULT',
                opr: 'E',
                amount: 0.00
            },
            deletePurchaseModel: false,
            deletePurchaseId: 0
        }
        this.bcacChild = React.createRef();
        this.gettransactionData = this.gettransactionData.bind(this);

        this.getDataByGrade = this.getDataByGrade.bind();
        this.previousPage = this.previousPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.getLowBalData = this.getLowBalData.bind(this);
        this.getDepositSummery = this.getDepositSummery.bind(this);
        this.deletePurchaseRec = this.deletePurchaseRec.bind(this)
    }
    componentWillMount = () => {
        let _queryString = queryString.parse(this.props.location.search)
        if ((_queryString.opr || '') !== '') {
            let _purchaseDataFilter = this.state.purchaseDataFilter;
            _purchaseDataFilter.tdate = 'C';
            _purchaseDataFilter.sdate = moment((_queryString.from || moment().format('DD-MMM-YYYY')), 'DD-MMM-YYYY')._d
            _purchaseDataFilter.edate = moment((_queryString.to || moment().format('DD-MMM-YYYY')), 'DD-MMM-YYYY')._d
            this.setState({ tabSelect: (_queryString.opr || ''), purchaseDataFilter: _purchaseDataFilter },
                this.getDataByGrade(0))
        } else {
            this.setState({ tabSelect: '' },
                this.getDataByGrade(0))
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        if (this.state.tabSelect != '') {
            if (document.getElementById('#' + this.state.tabSelect)) {
                document.getElementById('#' + this.state.tabSelect).click();
            }
        }
    }
    accountBalPdf = () => {
        get(`/reports/accBalanceSummary/${sessionStorage.getItem('SchoolId')}?isDistrict=false&isExport=true&access_token=`).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
            }
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "Account Balance Report";
            showFile(blob, filename);
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, this)
                this.setState({ loading: false })
            }
        )
    }
    buildAccountBalFormatForExport = () => {
        let fData = [];
        this.state.data.map(item => {
            if ((item.accBalance || 0.00) !== 0) {
                fData.push([{ value: item.studentId || '' }, { value: item.firstName || '' }, { value: item.lastName || '' }
                    , { value: item.accBalance || 0.00 }]);
            }
        })
        return (
            [{
                columns: [{ title: 'Student ID' }, { title: 'First Name' }, { title: 'Last Name' },
                { title: `Balance (${currency_symbol()})` }],
                data: fData
            }]
        )
    }
    purchaseSummery = (list) => {
        let groupObj = _.groupBy(list, 'itemPurchased');
        return (<ul style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>
            {
                Object.keys(groupObj).map((item) => {
                    return <li><label className="color-1">{'Total ' + item + ' Count: '}</label>  <strong className="color-4">{groupObj[item].length}</strong></li>
                })
            }
        </ul>)
    }
    deposistsSummery = (list) => {
        const _list = list.map(item => {
            item.type = (item.paymentType === "Online" ? item.paymentType :
                (item.note.includes('Lunch balance added from POS app.') ? item.paymentType + ' - By POS' :
                    item.paymentType + ' - By School'));
            return item;
        })
        let groupObj = _.groupBy(_list, 'type');
        return (<ul style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>
            {
                Object.keys(groupObj).map((item) => {
                    return <li><label className="color-1">{'Total ' + item + ' Count: '}</label>  <strong className="color-4">{groupObj[item].length}</strong></li>
                })
            }
        </ul>)
    }
    gettransactionData = (isDeposit, isPdf = false) => {
        let _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let filterObj = isDeposit ? this.state.tdataFilter : this.state.purchaseDataFilter
        let date = {}
        if (filterObj.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (filterObj.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (filterObj.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (filterObj.tdate === 'C') {
            date = { startDate: filterObj.sdate, endDate: filterObj.edate }
        } else {
            date = getTodayStartEndDates(new Date());
        }
        this.setState({ loading: true });
        //alert(this.state.tdataFilter.tdate)
        get('/reports/transactionsReport?mealSchoolId=' + userInfo.schoolId + '&startDate='
            + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&isDeposit=' + isDeposit +
            '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
            '&fileExport=' + isPdf + '&access_token=').then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                    //throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    // _addNotificationError(res.statusMessage,this)
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                if (isPdf) {
                    let filename = isDeposit ? 'Deposits_Report.pdf' : 'Purchase_Report.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {
                    console.log(JSON.stringify(data.transactionReportsDetails));
                    if (isDeposit) {
                        this.setState({
                            transactionData: data.transactionReportsDetails, loading: false
                        })
                    }
                    else {
                        this.setState({
                            purchaseData: data.transactionReportsDetails, loading: false
                        })
                    }
                }

            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    //console.log('Get Excel File response', error)
                    this.setState({ loading: false })
                }
            );
    }
    previousPage = () => {
        if (this.state.currentPage !== 0)
            this.setState({ currentPage: this.state.currentPage - 1 })
    }
    nextPage = () => {
        if ((this.state.currentPage + 1) * 20 < this.state.students.length)
            this.setState({ currentPage: this.state.currentPage + 1 })
    }
    getDataByGrade = (gradeName) => {
        let teachers = [];
        let studentsByGrade = [];
        this.setState({ loading: true });
        let schoolId = sessionStorage.getItem('SchoolId');
        (get('/studentUsers/search/findByIsActiveAndMealSchoolSchoolIdAndSchoolYear?isActive=true&schoolId=' + schoolId + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&access_token='))
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                console.log("allStudentData", this.state.allStudentData);
                console.log('data', data);
                const stData = data['_embedded']['studentUsers'];
                let activeStData = stData; //_.filter(stData, function(o) { return o.register; });
                this.setState({ studentsCount: activeStData.length, });
                if ((gradeName || '0') == '0') {
                    return activeStData.map(item => {
                        let _id = item.studentId;
                        return {
                            _id,
                            ...item
                        };
                    });
                } else {
                    activeStData.map(item => { //pushes all students for grade selected into an array
                        let _gradeName = item.gradeName;
                        if (_gradeName === gradeName) {
                            studentsByGrade.push(item);
                        }
                    });
                    return studentsByGrade.map(item => {
                        let _id = item.studentId;
                        return {
                            _id,
                            ...item
                        };
                    });
                }
            }).then(data => {
                /* You can do all the function calls from in here in the same .then(data => {}) call aboves */
                // console.log("Students by grade " + JSON.stringify(studentsByGrade));
                this.setState({ studentsCount: studentsByGrade.length });
                let columns = this.getColumns(data);

                this.setState({
                    students: data,
                    data: data,
                    columns: columns,
                    loading: false,
                    studentCount: data.length
                })
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    getColumns = (data) => {
        let columns = [];
        let header = ['NAME', 'MOBILE NO', 'PARENT EMAILID', 'A/C BALANCE', 'ACTIONS'];
        if (data.length === 0) {
            header.map(key =>
                columns.push({ Header: key }));
        }
        else {
            columns.push({
                accessor: 'firstName',
                Header: 'Student',
                Cell: props => <span>{props.original.lastName + ', ' + props.original.firstName} { }</span>,
                style: { textAlign: 'center' }
            });
            columns.push({
                accessor: 'parentuser.userName',
                Header: 'Parent',
                style: { textAlign: 'center' }
            });
            /* columns.push({
                accessor: 'mobileNo', // formatted mobile num for display
                Header: 'Mobile No',
                style: { textAlign: 'center' }
            }); */
            columns.push({
                accessor: 'accBalance', // formatted mobile num for display
                Header: `Balance (${currency_symbol()})`,
                style: { textAlign: 'center' },
                Cell: ({ row }) => (
                    <span style={{ textAlign: 'center' }}>
                        {currency_symbol() + ' ' + convertTwoDecimalPoint(row._original.accBalance)} </span>)
            });
            columns.push({
                Header: "Action",
                width: 100,
                style: { textAlign: 'center' },
                Cell: props => {
                    return (
                        <div>
                            <Link to={{
                                pathname: '/schoolAdmin/accountHistory/' + props.original.displayRecId,
                                state: {
                                    schoolId: 0
                                }
                            }}><i className="fa fa-list-alt"></i></Link>
                            {/* <a title="Click"
                        onClick={(event) =>{ 
                            this.context.router.history.push('/schoolAdmin/accountHistory/' + props.original.displayRecId)                           
                            //this.setState({accountHistStudentData:row.original,modalIsOpen:true})
                    }}><i className="fa fa-list-alt"/></a>  */}
                        </div>
                    )
                }
            })
        }
        return columns;
    }
    filterSchool = () => {
        let s = document.getElementById('search').value;
        //alert(s)
        let filteredData = this.state.students;
        let searchedSchool = [];
        if (s.length > 0) {

            filteredData.forEach(obj => {
                if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.mobileNum != null && (obj.mobileNum.replace(/[()\-" ]+/g, '').toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                } else if (obj.parentuser.userName != null && (obj.parentuser.userName.toLowerCase()).startsWith(s.toLowerCase())) {
                    searchedSchool.push(obj);
                }
            });
            //.replace(/[()\-" ]+/g, '')
            this.setState({ data: searchedSchool })
        }
        else {
            this.setState({ data: searchedSchool.length == 0 ? filteredData : searchedSchool })
        }
        this.forceUpdate();
    };
    getLowBalData = (isPdf = false) => {
        let _self = this;
        let _lowBalFilter = this.state.lowBalFilter
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let schoolYearValue = sessionStorage.getItem('schoolYearValue');
        let url = '';
        if (_lowBalFilter.filter == 'DEFAULT') {
            url = '/reports/lowBalanceReport?mealSchoolId=' + userInfo.schoolId + '&fileExport=' + isPdf + '&schoolYear=' + schoolYearValue + '&access_token='
        } else {
            url = '/reports/lowBalanceReport?mealSchoolId=' + userInfo.schoolId +
                '&fileExport=' + isPdf + '&schoolYear=' + schoolYearValue + '&amount=' + ((_lowBalFilter.amount === '' ? undefined : _lowBalFilter.amount) || 0.00) + '&operator=' + _lowBalFilter.opr + '&access_token='
        }
        this.setState({ loading: true });
        get(url).then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = 'Low_balReport.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                console.log(JSON.stringify(data.lowBalanceStudentsList));
                this.setState({
                    lowBalReport: data.lowBalanceStudentsList, mapKeyVal: data.mapKeyVal, loading: false
                })

            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );
    }
    getDepositSummery = (isPdf = false) => {
        let _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let filterObj = this.state.purchaseDataFilter
        let date = {}
        if (filterObj.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (filterObj.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (filterObj.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (filterObj.tdate === 'C') {
            date = { startDate: filterObj.sdate, endDate: filterObj.edate }
        } else {
            date = getTodayStartEndDates(new Date());
        }
        this.setState({ loading: true });
        get('/dashboard/balancePaymentTrend?mealSchoolId=' + userInfo.schoolId +
            '&startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss")
            + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
            '&fileExport=' + isPdf + '&access_token=').then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                    //throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    // _addNotificationError(res.statusMessage,this)
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                if (isPdf) {
                    let filename = 'Deposits_Summery.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {
                    let respData = [];
                    if (Object.keys(data).length > 0) {
                        Object.keys(data).map(item => {
                            respData.push({
                                transType: item,
                                noOfTrans: data[item].totalTransactions,
                                amount: data[item].totalAmount
                            });
                        })
                    }
                    this.setState({
                        depositSummery: respData, loading: false
                    })
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    //console.log('Get Excel File response', error)
                    this.setState({ loading: false })
                }
            );
    }
    deletePurchaseRec = () => {
        this.setState({ loading: true, deletePurchaseModel: false })
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        _delete("/transactions/removePurchaseTrx?trxId=" + this.state.deletePurchaseId + "&mealSchoolId=" + userInfo.schoolId + "&access_token=")
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                } else {
                    return response.json();
                }
            }).then((response) => {
                if (response.statusCode === 200) {
                    this.setState({ loading: false })
                    _addNotification(response.statusMessage, this);
                    this.gettransactionData(false, false)
                } else {
                    throw Error(response.errorMessage);
                }
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    _addNotificationError(error.message, this);
                }
            );
    }
    getPaymentEvent = (isPdf = false) => {
        let _self = this;
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let filterObj = this.state.eventPayDataFilter
        let date = {}
        if (filterObj.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (filterObj.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (filterObj.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (filterObj.tdate === 'C') {
            date = { startDate: filterObj.sdate, endDate: filterObj.edate }
        } else {
            date = getTodayStartEndDates(new Date());
        }
        this.setState({ loading: true });
        get('/reports/eventsReport?mealSchoolId=' + userInfo.schoolId +
            '&schoolYear=' + sessionStorage.getItem('schoolYearValue') +
            '&startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss")
            + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&access_token=').then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                    //throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    // _addNotificationError(res.statusMessage,this)
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                if (isPdf) {
                    let filename = 'purchase_events.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {
                    let eventList = [];
                    (data.response || []).forEach(item => {
                        let tot = 0.00;
                        (item.students || []).forEach(stud => {
                            stud['fullName'] = stud.lastName + ', ' + stud.firstName;
                            tot = tot + parseFloat(convertTwoDecimalPoint(stud.transactionAmount))
                        })
                        item['totalAmt'] = tot;
                        eventList.push(item)
                    })
                    this.setState({
                        eventsPayments: eventList, loading: false
                    })
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    //console.log('Get Excel File response', error)
                    this.setState({ loading: false })
                }
            );
    }
    render() {
        gradeList = getSchoolGrades();
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (<div>
            <NotificationSystem ref="notificationSystem" />
            <section className=" full-width clearfix">
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className="sectionTitle">
                        <h2 style={{ marginLeft: '15px' }}>
                            <span>Transaction Reports</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tabCommon custom-tabCommon">
                                <ul className="nav nav-tabs" role="tablist">
                                    <li role="presentation" className="active"><a style={{ padding: '0px 10px' }} href="#Section1" aria-controls="profile" id="#hist" role="tab" onClick={() => {
                                        this.getDataByGrade(this.state.tabIndex)
                                    }}
                                        data-toggle="tab">Account Balance</a></li>
                                    <li role="presentation"><a style={{ padding: '0px 10px' }} href="#Section2" aria-controls="profile" id="#lowBal"
                                        role="tab" onClick={() => { this.getLowBalData(false) }}
                                        data-toggle="tab">Low Balance Report</a></li>
                                    <li role="presentation"><a style={{ padding: '0px 10px' }} href="#Section3" id="#dep"
                                        aria-controls="home"
                                        role="tab" data-toggle="tab" onClick={() => { this.gettransactionData(true); }}>Deposits Report </a>
                                    </li>
                                    <li role="presentation"><a style={{ padding: '0px 10px' }} href="#Section4" aria-controls="profile" id="#depSum"
                                        role="tab" onClick={() => { this.getDepositSummery(false) }}
                                        data-toggle="tab">Deposit Summary</a></li>
                                    <li role="presentation"><a style={{ padding: '0px 10px' }} href="#Section5" aria-controls="profile" role="tab" id="#pur"
                                        data-toggle="tab" onClick={() => { this.gettransactionData(false); }}>Purchase Reports</a></li>



                                    {
                                        getAccessLevelByModule(modEnum.MPAE) ?
                                            <li role="presentation">
                                                <a style={{ padding: '0px 10px' }} href="#Section6" aria-controls="profile" id="#payEvent"
                                                    role="tab" onClick={() => { this.getPaymentEvent(false) }}
                                                    data-toggle="tab">Event Payments</a></li> : null
                                    }
                                    {
                                        getAccessLevelByModule(modEnum.BACP) ?
                                            <li role="presentation">
                                                <a style={{ padding: '0px 10px' }} href="#Section7" aria-controls="profile" id="#payBcac"
                                                    role="tab" onClick={() => {
                                                        this.bcacChild.current.init();
                                                    }}
                                                    data-toggle="tab">BCAC Payments</a></li> : null
                                    }
                                </ul>
                                <div className="tab-content">
                                    <div role="tabpanel" className="tab-pane active" id="Section1">
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Account Balance</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div>
                                                    <Tabs>
                                                        <TabList>
                                                            <div className="button-group-section">
                                                                <TmExportExcel
                                                                    name={"Account balance"}
                                                                    filename={"Account balance"}
                                                                    element={<button className="btn btn-warning btn-sm pull-right" style={{ marginTop: '-11px' }}><i className="fa fa-file-excel-o"></i> Export</button>}
                                                                    dataSet={this.buildAccountBalFormatForExport()}
                                                                />
                                                                <button className="btn btn-primary btn-sm pull-right" style={{ marginTop: '-11px' }} onClick={() => {
                                                                    this.accountBalPdf();
                                                                }}><i className="fa fa-file-pdf-o"></i> PDF</button>

                                                            </div>
                                                            {/* <Tab onClick={() => {
                                                                this.setState({ selectAll: false })
                                                                this.state.tabIndex = 0;
                                                            this.getDataByGrade(0) 
                                                        }}>All Grades</Tab> */}
                                                            {gradeList.map((item) => {
                                                                return <Tab onClick={() => {
                                                                    this.state.tabIndex = item.value;
                                                                    this.setState({ selectAll: false })
                                                                    this.getDataByGrade(item.value);
                                                                }}> {item.label}</Tab>
                                                            }, this)}
                                                        </TabList>
                                                        <TabPanel>
                                                            <div className="row">
                                                                <div className="col-xs-12 pull-left">
                                                                    <input type="text" id="search"
                                                                        className="search form-control"
                                                                        style={{
                                                                            float: 'left',
                                                                            margin: '5px 0'
                                                                        }}
                                                                        name="search"
                                                                        placeholder="Search.."
                                                                        onKeyUp={this.filterSchool} />
                                                                </div>
                                                            </div>
                                                            <ReactTable className="-striped -highlight"
                                                                ref={r => (this.checkboxTable = r)}
                                                                data={_.orderBy(this.state.data, ['lastName', 'firstName'], ['asc'])}
                                                                columns={this.state.columns}
                                                                defaultPageSize={10}
                                                                {...checkboxProps}
                                                            />
                                                        </TabPanel>
                                                        {gradeList.map(function (key) {
                                                            return (
                                                                <TabPanel>
                                                                    <div className="row">
                                                                        <div className="col-xs-12 pull-left">
                                                                            <input type="text" id="search"
                                                                                className="search form-control"
                                                                                style={{
                                                                                    float: 'left',
                                                                                    margin: '5px 0'
                                                                                }}
                                                                                name="search"
                                                                                placeholder="Search.."
                                                                                onKeyUp={this.filterSchool} />
                                                                        </div>
                                                                    </div>
                                                                    <ReactTable className="-striped -highlight"
                                                                        ref={r => (this.checkboxTable = r)}
                                                                        data={_.orderBy(this.state.data, ['lastName', 'firstName'], ['asc'])}
                                                                        columns={this.state.columns}
                                                                        defaultPageSize={10}
                                                                        {...checkboxProps}

                                                                    />
                                                                </TabPanel>)
                                                        }, this)}
                                                    </Tabs>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="Section2">
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Low Balance Report</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="col-md-12">
                                                    <div className="alert alert-info " style={{ textAlign: "left", padding: "10px" }}>
                                                        <div className="row">
                                                            <div className="col-md-11">
                                                                <ul>
                                                                    <li><input type="radio" name="lowBalFilter" checked={this.state.lowBalFilter.filter == 'DEFAULT'} defaultChecked={true}
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                let _lowBalFilter = this.state.lowBalFilter;
                                                                                _lowBalFilter.filter = 'DEFAULT';
                                                                                this.setState({ lowBalFilter: _lowBalFilter },
                                                                                    this.getLowBalData(false))
                                                                            }
                                                                        }} /><span style={{ marginLeft: '10px' }}>LOW BALANCE CRITERIA RANGE ({currency_symbol()}): {this.state.mapKeyVal.minLowBalance + ' to ' + this.state.mapKeyVal.maxLowBalance}</span></li>
                                                                    <li><input type="radio" style={{ position: 'absolute', marginTop: '10px' }} checked={this.state.lowBalFilter.filter == 'CUSTOM'} name="lowBalFilter"
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                let _lowBalFilter = this.state.lowBalFilter;
                                                                                _lowBalFilter.filter = 'CUSTOM';
                                                                                this.setState({ lowBalFilter: _lowBalFilter },
                                                                                    this.getLowBalData(false))
                                                                            }
                                                                        }} />
                                                                        <div style={{ marginLeft: '23px', display: 'inline-table' }}>
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <select className="form-control" value={this.state.lowBalFilter.opr} onChange={(e) => {
                                                                                        let _lowBalFilter = this.state.lowBalFilter;
                                                                                        _lowBalFilter.opr = e.target.value;
                                                                                        this.setState({ lowBalFilter: _lowBalFilter })
                                                                                    }}>
                                                                                        <option value="E">Equals</option>
                                                                                        <option value="L">Less than</option>
                                                                                        <option value="LE">Less than equals</option>
                                                                                        <option value="G">Greater than</option>
                                                                                        <option value="GE">Greater than equals</option>
                                                                                    </select>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <input type="number" className="form-control" value={this.state.lowBalFilter.amount} placeholder="0.00" onChange={(e) => {
                                                                                        let _lowBalFilter = this.state.lowBalFilter;
                                                                                        _lowBalFilter.amount = e.target.value;
                                                                                        this.setState({ lowBalFilter: _lowBalFilter })
                                                                                    }} />
                                                                                </div>
                                                                                <div className="col-md-1">
                                                                                    <button type='button' className="btn btn-xs btn-success" style={{ margin: '0px' }} onClick={() => {
                                                                                        this.getLowBalData(false);
                                                                                    }}>Go</button>
                                                                                </div>

                                                                            </div>
                                                                        </div></li>
                                                                </ul>
                                                            </div>
                                                            <div className="col-md-1">
                                                                <a title="Click to Download PDF"
                                                                    onClick={() => { this.getLowBalData(true) }//this.quickReports('Pdf','currentDay')
                                                                    } target='_blank'
                                                                    className="fa fa-file-pdf-o fa-2x pull-right"><i /></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <LowBalReport lowBalData={this.state.lowBalReport} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="Section3">
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Deposits Report</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="col-md-12"><div className="alert alert-info ">
                                                    <div onChange={(event) => {
                                                        let tdataFilter = this.state.tdataFilter;
                                                        tdataFilter.tdate = event.target.value;
                                                        this.setState({ tdataFilter: tdataFilter })
                                                        if (event.target.value !== 'C')
                                                            this.gettransactionData(true, false);
                                                    }}>
                                                        <label class="rbcontainer">Today
                                                            <input type="radio" name="drange" value="D" defaultChecked={this.state.tdataFilter.tdate === 'D'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Week
                                                            <input type="radio" name="drange" value="W" defaultChecked={this.state.tdataFilter.tdate === 'W'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Month
                                                            <input type="radio" name="drange" value="M" defaultChecked={this.state.tdataFilter.tdate === 'M'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Year
                                                            <input type="radio" name="drange" value="Y" defaultChecked={this.state.tdataFilter.tdate === 'Y'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">Custom Date Range
                                                            <input type="radio" name="drange" value="C" defaultChecked={this.state.tdataFilter.tdate === 'C'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        {
                                                            this.state.tdataFilter.tdate === 'C' ?
                                                                <DateRangePicker onApply={(event, picker) => {
                                                                    let tdataFilter = this.state.tdataFilter;
                                                                    tdataFilter.sdate = picker.startDate._d;
                                                                    tdataFilter.edate = picker.endDate._d;
                                                                    this.setState({ tdataFilter: tdataFilter })
                                                                    this.gettransactionData(true, false);
                                                                    console.log('sdate --:', event, picker)
                                                                }}>
                                                                    <button className="btn btn-xs bg-color-1" style={{ margin: '0px' }}><i className="fa fa-calendar"></i></button>
                                                                </DateRangePicker> : null

                                                        }
                                                        <a title="Click to Download PDF"
                                                            onClick={() => { this.gettransactionData(true, true) }//this.quickReports('Pdf','currentDay')
                                                            } target='_blank'
                                                            className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>

                                                    </div>
                                                </div></div>
                                                <div className="col-md-12">
                                                    {this.deposistsSummery(this.state.transactionData)}
                                                </div>
                                                <div className="col-md-12">
                                                    <ReactTable
                                                        filterable
                                                        columns={[
                                                            {
                                                                Header: "Student",
                                                                id: "Student",
                                                                style: { textAlign: 'center' },
                                                                accessor: row => {
                                                                    return (
                                                                        <span>
                                                                            {row.studentLName + ', ' + row.studentFName}
                                                                        </span>
                                                                    );
                                                                },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row.studentLName + ', ' + _row.studentFName).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                },
                                                                Footer: <div style={{ textAlign: "center" }}>Total:  {this.state.transactionData.length}</div>
                                                            },
                                                            {
                                                                Header: "Date",
                                                                accessor: "transactionDate",
                                                                width: 100,
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row['transactionDate']).startsWith(filter.value.toLowerCase())
                                                                },
                                                            },
                                                            {
                                                                Header: "Time",
                                                                accessor: "transactionTime",
                                                                width: 100,
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row['transactionTime']).startsWith(filter.value.toLowerCase())
                                                                },
                                                            },
                                                            {
                                                                Header: "Type",
                                                                id: 'type',
                                                                style: { textAlign: 'center' },
                                                                accessor: 'type'
                                                                /* accessor: row => {
                                                                    return (
                                                                        <span>
                                                                            {
                                                                            row.paymentType === "Online" ? row.paymentType :
                                                                            (row.note.includes('Lunch balance added from POS app.')? row.paymentType+' - By POS':
                                                                            row.paymentType + ' - By School') 
                                                                            }
                                                                        </span>
                                                                    );
                                                                } */
                                                                , width: 150,
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    //return (_row['paymentType']).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                    return (_row['type']).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                },
                                                                Filter: ({ filter, onChange }) => {
                                                                    return (
                                                                        <select className="form-control"
                                                                            onChange={event => onChange(event.target.value)}
                                                                            value={filter ? filter.value : 'all'}
                                                                        >
                                                                            <option value={''}>{''}</option>
                                                                            {_.map(
                                                                                _.uniq(
                                                                                    _.map(this.state.transactionData, function (obj) {
                                                                                        //return obj.paymentType;
                                                                                        return obj.type;
                                                                                    })
                                                                                )).map(item =>
                                                                                    <option value={item}>{item}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                Header: `Amount (${currency_symbol()})`,
                                                                id: 'amount',
                                                                width: 100,
                                                                filterable: false,
                                                                accessor: row => {
                                                                    return (
                                                                        <div style={{ textAlign: "center" }}>
                                                                            {currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}
                                                                        </div>
                                                                    );
                                                                },
                                                                Footer: <div style={{ textAlign: "center" }}> {currency_symbol() + ' ' + (_.sum(_.map(this.state.transactionData, d => d.amount))).toFixed(2)}</div>
                                                            },
                                                            {
                                                                Header: "Check/CC TX. No./TX. ID",
                                                                id: 'transaction',
                                                                style: { textAlign: 'center' },
                                                                accessor: row => {
                                                                    return (
                                                                        <span>
                                                                            {row.paymentType === "Online" ? row.transferId :
                                                                                (row.paymentType === "CreditCard" ? row.checkNum :
                                                                                    (row.paymentType === 'Check' ? row.checkNum : null))}
                                                                        </span>
                                                                    );
                                                                },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    const _fieldName = ['transferId', 'checkNum']
                                                                    return ((_row[_fieldName[0]]).toLowerCase().startsWith(filter.value.toLowerCase()) ||
                                                                        (_row[_fieldName[1]]).toLowerCase().startsWith(filter.value.toLowerCase()))
                                                                }
                                                            },
                                                            {
                                                                Header: "User",
                                                                accessor: "user",
                                                                minWidth: 120,
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                }
                                                            }

                                                        ]} data={(_.orderBy(this.state.transactionData, ['studentLName', 'studentFName'], ['asc']) || []).map(item => {
                                                            item.type = (item.paymentType === "Online" ? item.paymentType :
                                                                (item.note.includes('Lunch balance added from POS app.') ? item.paymentType + ' - By POS' :
                                                                    item.paymentType + ' - By School'));
                                                            return item;
                                                        })} defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="Section4">
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Deposit Summary</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="col-md-12"><div className="alert alert-info ">
                                                    <div onChange={(event) => {
                                                        let purchaseDataFilter = this.state.purchaseDataFilter;
                                                        purchaseDataFilter.tdate = event.target.value;
                                                        this.setState({ purchaseDataFilter: purchaseDataFilter })
                                                        if (event.target.value !== 'C')
                                                            this.getDepositSummery(false);
                                                    }}>
                                                        <label class="rbcontainer">Today
                                                            <input type="radio" name="pdrange" value="D" defaultChecked={this.state.purchaseDataFilter.tdate === 'D'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Week
                                                            <input type="radio" name="pdrange" value="W" defaultChecked={this.state.purchaseDataFilter.tdate === 'W'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Month
                                                            <input type="radio" name="pdrange" value="M" defaultChecked={this.state.purchaseDataFilter.tdate === 'M'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Year
                                                            <input type="radio" name="pdrange" value="Y" defaultChecked={this.state.purchaseDataFilter.tdate === 'Y'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">Custom Date Range
                                                            <input type="radio" name="pdrange" value="C" defaultChecked={this.state.purchaseDataFilter.tdate === 'C'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        {
                                                            this.state.purchaseDataFilter.tdate === 'C' ?
                                                                <DateRangePicker startDate={this.state.purchaseDataFilter.sdate} endDate={this.state.purchaseDataFilter.edate} onApply={(event, picker) => {
                                                                    let purchaseDataFilter = this.state.purchaseDataFilter;
                                                                    purchaseDataFilter.sdate = picker.startDate._d;
                                                                    purchaseDataFilter.edate = picker.endDate._d;
                                                                    this.setState({ purchaseDataFilter: purchaseDataFilter })
                                                                    this.getDepositSummery(false);
                                                                    console.log('sdate --:', event, picker)
                                                                }}>
                                                                    <button className="btn btn-xs bg-color-1" style={{ margin: '0px' }}><i className="fa fa-calendar"></i></button>
                                                                </DateRangePicker> : null
                                                        }
                                                        <a title="Click to Download PDF"
                                                            onClick={() => { this.getDepositSummery(true) }//this.quickReports('Pdf','currentDay')
                                                            } target='_blank'
                                                            className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                                    </div>
                                                </div></div>
                                                <div className="col-md-12">
                                                    <ReactTable
                                                        filterable
                                                        columns={[
                                                            {
                                                                Header: "S.No",
                                                                filterable: false,
                                                                width: 100,
                                                                style: { textAlign: 'center' },
                                                                Cell: row => {
                                                                    return <span>{row.index + 1}</span>
                                                                }
                                                            },
                                                            {
                                                                Header: "Transaction Type",
                                                                accessor: "transType",
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                },
                                                                Filter: ({ filter, onChange }) => {
                                                                    return (
                                                                        <select className="form-control"
                                                                            onChange={event => onChange(event.target.value)}
                                                                            value={filter ? filter.value : 'all'}
                                                                        >
                                                                            <option value={''}>{''}</option>
                                                                            {_.map(
                                                                                _.uniq(
                                                                                    _.map(this.state.depositSummery, function (obj) {
                                                                                        return obj.transType;
                                                                                    })
                                                                                )).map(item =>
                                                                                    <option value={item}>{item}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                Header: "Total Transactions",
                                                                filterable: false,
                                                                accessor: "noOfTrans",
                                                                style: { textAlign: 'center' },
                                                                Cell: row => (<span style={{ textAlign: 'center' }}>{row.original.noOfTrans}</span>)
                                                            },
                                                            {
                                                                Header: "Transaction Amount",
                                                                accessor: "amount",
                                                                style: { textAlign: 'center' },
                                                                filterable: false,
                                                                Cell: row => (<span style={{ textAlign: 'center' }}>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.original.amount)}</span>)
                                                            }
                                                        ]} data={this.state.depositSummery} defaultPageSize={10} className="-striped -highlight" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="Section5">
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Purchase Reports</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="col-md-12">
                                                    <div className="alert alert-info ">
                                                        <div onChange={(event) => {
                                                            let purchaseDataFilter = this.state.purchaseDataFilter;
                                                            purchaseDataFilter.tdate = event.target.value;
                                                            this.setState({ purchaseDataFilter: purchaseDataFilter })
                                                            if (event.target.value !== 'C')
                                                                this.gettransactionData(false, false);
                                                        }}>
                                                            <label class="rbcontainer">Today
                                                                <input type="radio" name="pdrange" value="D" checked={this.state.purchaseDataFilter.tdate === 'D'} />
                                                                <span className="rbcheckmark"></span>
                                                            </label>
                                                            <label class="rbcontainer">This Week
                                                                <input type="radio" name="pdrange" value="W" defaultChecked={this.state.purchaseDataFilter.tdate === 'W'} />
                                                                <span className="rbcheckmark"></span>
                                                            </label>
                                                            <label class="rbcontainer">This Month
                                                                <input type="radio" name="pdrange" value="M" defaultChecked={this.state.purchaseDataFilter.tdate === 'M'} />
                                                                <span className="rbcheckmark"></span>
                                                            </label>
                                                            <label class="rbcontainer">This Year
                                                                <input type="radio" name="pdrange" value="Y" defaultChecked={this.state.purchaseDataFilter.tdate === 'Y'} />
                                                                <span className="rbcheckmark"></span>
                                                            </label>
                                                            <label class="rbcontainer">Custom Date Range
                                                                <input type="radio" name="pdrange" value="C" defaultChecked={this.state.purchaseDataFilter.tdate === 'C'} />
                                                                <span className="rbcheckmark"></span>
                                                            </label>
                                                            {
                                                                this.state.purchaseDataFilter.tdate === 'C' ?
                                                                    <DateRangePicker onApply={(event, picker) => {
                                                                        let purchaseDataFilter = this.state.purchaseDataFilter;
                                                                        purchaseDataFilter.sdate = picker.startDate._d;
                                                                        purchaseDataFilter.edate = picker.endDate._d;
                                                                        this.setState({ purchaseDataFilter: purchaseDataFilter })
                                                                        this.gettransactionData(false, false);
                                                                        console.log('sdate --:', event, picker)
                                                                    }}>
                                                                        <button className="btn btn-xs bg-color-1" style={{ margin: '0px' }}><i className="fa fa-calendar"></i></button>
                                                                    </DateRangePicker> : null
                                                            }
                                                            <a title="Click to Download PDF"
                                                                onClick={() => { this.gettransactionData(false, true) }//this.quickReports('Pdf','currentDay')
                                                                } target='_blank'
                                                                className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                                        </div>
                                                    </div></div>
                                                <div className="col-md-12">
                                                    {this.purchaseSummery(this.state.purchaseData)}
                                                </div>
                                                <div className="col-md-12">
                                                    <ReactTable
                                                        filterable
                                                        columns={[
                                                            {
                                                                Header: "Student",
                                                                id: "Student",
                                                                style: { textAlign: 'center' },
                                                                accessor: row => {
                                                                    return (
                                                                        <span>
                                                                            {row.studentLName + ', ' + row.studentFName}
                                                                        </span>
                                                                    );
                                                                },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row.studentLName + ', ' + _row.studentFName).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                },
                                                                Footer: <div style={{ textAlign: "center" }}>Total:  {this.state.purchaseData.length}</div>
                                                            },
                                                            {
                                                                Header: "Date",
                                                                accessor: "transactionDate",
                                                                width: 100,
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                }
                                                            },
                                                            {
                                                                Header: "Time",
                                                                accessor: "transactionTime",
                                                                width: 100,
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                }
                                                            },
                                                            {
                                                                Header: "Type",
                                                                id: 'type',
                                                                style: { textAlign: 'center' },
                                                                accessor: row => {
                                                                    return (
                                                                        <span>
                                                                            {row.itemPurchased === "TransferDR" ? 'Transfer Withdrawal' : row.itemPurchased}
                                                                        </span>
                                                                    );
                                                                },
                                                                width: 100,
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row['itemPurchased']).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                },
                                                                Filter: ({ filter, onChange }) => {
                                                                    return (
                                                                        <select className="form-control"
                                                                            onChange={event => onChange(event.target.value)}
                                                                            value={filter ? filter.value : 'all'}
                                                                        >
                                                                            <option value={''}>{''}</option>
                                                                            {_.map(
                                                                                _.uniq(
                                                                                    _.map(this.state.purchaseData, function (obj) {
                                                                                        return obj.itemPurchased;
                                                                                    })
                                                                                )).map(item =>
                                                                                    <option value={item}>{item}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                Header: "Category",
                                                                accessor: "category",
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                }
                                                            },
                                                            {
                                                                Header: `Amount (${currency_symbol()})`,
                                                                id: 'amount',
                                                                width: 150,
                                                                filterable: false,
                                                                accessor: row => {
                                                                    return (
                                                                        <div style={{ textAlign: "center" }}>
                                                                            {currency_symbol() + ' ' + convertTwoDecimalPoint(row.amount)}
                                                                        </div>
                                                                    );
                                                                },
                                                                Footer: <div style={{ textAlign: "center" }}>{currency_symbol() + ' ' + (_.sum(_.map(this.state.purchaseData, d => d.amount))).toFixed(2)}</div>
                                                            },
                                                            {
                                                                Header: "Description",
                                                                accessor: "transactionDesc",
                                                                style: { textAlign: 'center' },
                                                                filterable: false
                                                            }, {
                                                                Header: 'Action',
                                                                id: 'action',
                                                                filterable: false,
                                                                style: { textAlign: 'center' },
                                                                minWidth: 50,
                                                                Cell: row => {
                                                                    return (
                                                                        <a title="Delete Transaction" onClick={() => {
                                                                            const id = row.original.idNumb || 0;
                                                                            this.setState({ deletePurchaseModel: true, deletePurchaseId: id })
                                                                        }}><b><i className="fa tbl-rounded-icon fa-icon fa-trash bg-color-3"></i></b></a>
                                                                    )
                                                                }
                                                            }
                                                        ]} data={_.orderBy(this.state.purchaseData, ['studentLName', 'studentFName'], ['asc'])} defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="Section6">
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Event Purchases</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="alert alert-info ">
                                                            <div onChange={(event) => {
                                                                let eventPayDataFilter = this.state.eventPayDataFilter;
                                                                eventPayDataFilter.tdate = event.target.value;
                                                                this.setState({ eventPayDataFilter: eventPayDataFilter }, () => {
                                                                    if (this.state.eventPayDataFilter.tdate !== 'C')
                                                                        this.getPaymentEvent();
                                                                })
                                                            }}>
                                                                <label class="rbcontainer">Today
                                                                    <input type="radio" name="edrange" value="D" checked={this.state.eventPayDataFilter.tdate === 'D'} />
                                                                    <span className="rbcheckmark"></span>
                                                                </label>
                                                                <label class="rbcontainer">This Week
                                                                    <input type="radio" name="edrange" value="W" checked={this.state.eventPayDataFilter.tdate === 'W'} />
                                                                    <span className="rbcheckmark"></span>
                                                                </label>
                                                                <label class="rbcontainer">This Month
                                                                    <input type="radio" name="edrange" value="M" checked={this.state.eventPayDataFilter.tdate === 'M'} />
                                                                    <span className="rbcheckmark"></span>
                                                                </label>
                                                                <label class="rbcontainer">This Year
                                                                    <input type="radio" name="edrange" value="Y" checked={this.state.eventPayDataFilter.tdate === 'Y'} />
                                                                    <span className="rbcheckmark"></span>
                                                                </label>
                                                                <label class="rbcontainer">Custom Date Range
                                                                    <input type="radio" name="edrange" value="C" checked={this.state.eventPayDataFilter.tdate === 'C'} />
                                                                    <span className="rbcheckmark"></span>
                                                                </label>
                                                                {
                                                                    this.state.eventPayDataFilter.tdate === 'C' ?
                                                                        <DateRangePicker startDate={this.state.eventPayDataFilter.sdate} endDate={this.state.eventPayDataFilter.edate} onApply={(event, picker) => {
                                                                            let eventPayDataFilter = this.state.eventPayDataFilter;
                                                                            eventPayDataFilter.sdate = picker.startDate._d;
                                                                            eventPayDataFilter.edate = picker.endDate._d;
                                                                            this.setState({ eventPayDataFilter: eventPayDataFilter })
                                                                            this.getPaymentEvent();
                                                                            console.log('sdate --:', event, picker)
                                                                        }}>
                                                                            <button className="btn btn-xs bg-color-1" style={{ margin: '0px' }}><i className="fa fa-calendar"></i></button>
                                                                        </DateRangePicker> : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <ReactTable className="-striped -highlight" {...checkboxProps}
                                                            filterable
                                                            columns={[
                                                                {
                                                                    Header: "Event Name",
                                                                    accessor: "eventName",
                                                                    style: { textAlign: 'center' },
                                                                    filterMethod: (filter, row) => {
                                                                        return (row._original.eventName.toLowerCase().startsWith(filter.value.toLowerCase()))
                                                                    },
                                                                    Footer: <div style={{ textAlign: "center" }}>Total :</div>
                                                                },
                                                                {
                                                                    Header: "Total Amount ($)",
                                                                    accessor: "totalAmt",
                                                                    style: { textAlign: 'center' },
                                                                    width: 150,
                                                                    Cell: row => <span>{row.value.toFixed(2)}</span>,
                                                                    Footer: <div style={{ textAlign: "center" }}>$ {(_.sum(_.map(this.state.eventsPayments, d => d.totalAmt))).toFixed(2)}</div>
                                                                }
                                                            ]} data={this.state.eventsPayments || []}
                                                            defaultPageSize={10} minRows={0}
                                                            SubComponent={(row) => {
                                                                return (
                                                                    <ReactTable filterable className="-striped -highlight" {...checkboxProps}
                                                                        columns={[
                                                                            {
                                                                                Header: "Name",
                                                                                accessor: "fullName",
                                                                                filterMethod: (filter, row) => {
                                                                                    return (row._original.fullName.toLowerCase().startsWith(filter.value.toLowerCase()))
                                                                                }
                                                                            },
                                                                            {
                                                                                Header: 'Transaction Date',
                                                                                accessor: 'trxDateTime',
                                                                                width: 200
                                                                            },
                                                                            {
                                                                                Header: "Amount ($)",
                                                                                accessor: 'transactionAmount',
                                                                                style: { textAlign: 'right' },
                                                                                width: 150,
                                                                                Cell: row => <span>{row.value.toFixed(2)}</span>
                                                                            }
                                                                        ]}
                                                                        data={row.original.students || []}
                                                                        defaultPageSize={10} minRows={0} />
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div role="tabpanel" className="tab-pane" id="Section7">
                                        <BcacPayments ref={this.bcacChild} gradeList={gradeList} {...this.props} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*  <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.setState({modalIsOpen: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                    <div className="modal-header row">
                                <h4 className="modal-title modal-title-color col-md-11" id="deleteLabel">{'Account History : '+this.state.accountHistStudentData.firstName+' '+this.state.accountHistStudentData.lastName}</h4>                                
                                <div className="col-md-1"><button type="button" className="pull-right color-1" onClick={() => {this.setState({modalIsOpen: false})}}>X</button></div>
                        </div>
                        <div className="modal-body">
                        <div className="row">                        
                        <AccountHistory student={this.state.accountHistStudentData}  filterData={this.state.hdataFilter} />
                        </div>
                        </div>
                    </Modal> */}
                <Modal
                    isOpen={this.state.deletePurchaseModel}
                    onRequestClose={() => this.setState({ deletePurchaseModel: false, deletePurchaseId: 0 })}
                    style={deleteStyles}
                    contentLabel="Publish">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting a Transaction</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to continue?</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ deletePurchaseModel: false, deletePurchaseId: 0 })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> No
                        </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={this.deletePurchaseRec}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Yes
                        </button>
                    </div>
                </Modal>
            </section>
        </div>);
    }

}
PaymentReports.contextTypes = { router: PropTypes.object.isRequired }
export default PaymentReports;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/PaymentReports/paymentReport.jsx